// FILE HANDLES CART OPERATIONS
// CART=[{}] LOCAL STORAGE ARRAY OF OBJECTS
// EACH OBJ={
//   PRODUCT_ID
//   IMAGE
//   NAME,PRICE,QUANTITY
// }

// CRUD FUNCTIONS
// *  1. GET CART
function getCart() {
  return JSON.parse(localStorage.getItem('dmcart')) || [];
}

// *  2. SAVE CART
export function saveCart(cart) {
  localStorage.setItem('dmcart', JSON.stringify(cart));
}

// * 3. ADD TO CART
function addToCart(product) {
  let cart = getCart();
  const existing = cart.find((item) => item.productId === product.productId);

  if (existing) {
    existing.quantity += product.quantity || 1;
  } else {
    cart.push({ ...product, quantity: product.quantity || 1 });
  }

  saveCart(cart);
  return cart;
}

// * 4. UPDATE QUANTITY
function updateQuantity(productId, quantity = 1) {
  let cart = getCart()
    .map((item) => {
      if (item.productId === productId) {
        if (item.quantity + quantity > 0) {
          item.quantity += quantity;
        } else return null;
      }
      return item;
    })
    .filter(Boolean);

  const newTotal = cart.reduce(
    (acc, item) => (acc += item.price * item.quantity),
    0
  );
  console.log(newTotal);
  const totalEl = document.querySelector('#total');
  totalEl.textContent = newTotal;

  saveCart(cart);
  return cart;
}

// * RENDER CART
// Example cart structure:
// [{ id: 1, name: "Xerox Altalink CB717", price: 570000, quantity: 2, img: "/img/dp-1.jpeg" }]

function renderCart() {
  const cart = getCart();
  let total = 0;
  console.log(cart);
  if (!cart.length) return `<p class="empty">Your cart is empty</p>`;

  const htmlString = cart
    .map((item) => {
      total += item.price * item.quantity;
      const url = `${window.location.protocol}//${window.location.host}/product/${item.slug}`;
      return `
          <div class="item" data-id="${item.productId}">
          <a href="${url}">
          <img src="${item.img}" alt="${item.name}" />
          </a>
          <div class="item-info">
            <h4>${item.name}</h4>
            <p>₹${item.price}</p>
            <div class="quantity-cont">
              <button class="dec-quantity">-</button>
              <span>${item.quantity}</span>
              <button class="inc-quantity">+</button>
              <button class="remove">remove</button>
            </div>
          </div>
          </div>
      `;
    })
    .join('');

  const totalEl = document.querySelector('#total');
  totalEl.textContent = total;
  return htmlString;
}

// ! MAIN CART FNXS
export const loadCart = function (cartItemsEl) {
  cartItemsEl.innerHTML = renderCart();

  const increaseBtns = document.querySelectorAll('.inc-quantity');
  const decreaseBtns = document.querySelectorAll('.dec-quantity');
  const removeBtns = document.querySelectorAll('.remove');

  increaseBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const prodId = e.target.closest('.item').dataset.id;
      const currQuan = e.target.closest('.quantity-cont').querySelector('span');
      updateQuantity(prodId, 1);
      currQuan.textContent = Number(currQuan.textContent) + 1;
    });
  });

  decreaseBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const prodId = e.target.closest('.item').dataset.id;
      const currQuan = e.target.closest('.quantity-cont').querySelector('span');
      updateQuantity(prodId, -1);
      if (Number(currQuan.textContent) - 1 > 0)
        currQuan.textContent = Number(currQuan.textContent) - 1;
      else {
        const item = e.target.closest('.item');
        item.remove();
      }
    });
  });

  removeBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      // trick-> get curr quantity from quantity
      // then pass -currQuantity in updateQuantity
      const prodId = e.target.closest('.item').dataset.id;
      const currQuan = e.target.closest('.quantity-cont').querySelector('span');
      updateQuantity(prodId, currQuan * -1);
      const item = e.target.closest('.item');
      item.remove();
    });
  });
};

export const addToCartTrigger = function (addBtn) {
  const {
    _id: productId,
    name,
    coverImage: img,
    discountedPrice: price,
    slug,
  } = { ...JSON.parse(addBtn.dataset.prod) };

  addToCart({
    productId,
    name,
    img,
    price,
    slug,
  });
  addBtn.innerText = 'Added to Cart!';
};
